var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95996 20.3199C8.50996 20.3199 8.95996 19.8899 8.95996 19.3599V4.64994C8.95996 4.11994 8.50996 3.68994 7.95996 3.68994C7.40996 3.68994 6.95996 4.11994 6.95996 4.64994V19.3599C6.95996 19.8899 7.40996 20.3199 7.95996 20.3199Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.04 20.3199C16.59 20.3199 17.04 19.8899 17.04 19.3599V4.64994C17.04 4.11994 16.59 3.68994 16.04 3.68994C15.49 3.68994 15.04 4.11994 15.04 4.64994V19.3599C15.04 19.8899 15.49 20.3199 16.04 20.3199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPause);
export default __webpack_public_path__ + "static/media/icon-pause.a9df1eda14b5a16bb8b18c90ff0a10e6.svg";
export { ForwardRef as ReactComponent };